import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../components/global/modal/withModal';
import ContributorActions from './ContributorActions';

export const CONTRIBUTOR_ACTIONS_MODAL = 'modal/CONTRIBUTOR_ACTIONS';

const propTypes = {
  actionProps: PropTypes.shape({
    entity: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

const ContributorActionsModal = ({ actionProps: { entity }, ...props }) => {
  return <ContributorActions entity={entity} {...props} />;
};

ContributorActionsModal.propTypes = propTypes;

export default withModal(ContributorActionsModal, {
  name: CONTRIBUTOR_ACTIONS_MODAL,
  size: 'lg',
  type: 'full',
  dismissible: false,
});
